export default "__VITE_ASSET__Bny_cj_j__"